import { Component, HostBinding } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IAfterGuiAttachedParams, ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-image-cell-renderer',
  templateUrl: './image-cell-renderer.component.html',
  styleUrls: ['./image-cell-renderer.component.scss']
})
export class ImageCellRendererComponent implements ICellRendererAngularComp {

  @HostBinding('style.background') backgroundColor = 'black';

  public color;

  refresh(params: any): boolean {
    this.color = params.value
    return true;
  }
  
  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {
    //throw new Error('Method not implemented.');
  }


  agInit(params: ICellRendererParams): void {
    this.color = params.value;
  }

  ngOnDestroy() {
  }

}
